import { NewsFeedsType } from '@pages/dashboards/shared/utils/constants';
import { MdsIcon } from '@mds/icons';

export const getNewsFeedImagePath = (news: any): string => {
  let image = '';
  switch (news.feed_type) {
    case NewsFeedsType.REPORT_NEWS:
      image = './assets/icons/app/pivot_manager/gwp_report.svg';
      break;
    case NewsFeedsType.IMPORT_COMPONENT:
      image = './assets/icons/app/tools/importer.svg';
      break;
    case NewsFeedsType.PRODUCT_ANALYSIS:
      image = './assets/icons/svg-imports/newsfeed/analyze.svg';
      break;
    case NewsFeedsType.SHARING_NEWS:
      switch (news.type?.toLowerCase()) {
        case 'product group':
          image = './assets/icons/composer-data-objects/product-group.svg';
          break;
        case 'product':
          image = './assets/icons/composer-data-objects/product.svg';
          break;
        case 'process':
          image = './assets/icons/composer-data-objects/process.svg';
          break;
        default:
          image = './assets/icons/composer-data-objects/product.svg';
          break;
      }
      break;
    default:
      break;
  }
  return image;
};

export const getNewsFeedActionIcon = (feedType: NewsFeedsType) => {
  let iconName = '';
  switch (feedType) {
    case NewsFeedsType.TEAM_MEMBER_NEWS:
      iconName = MdsIcon.VIEW_PROFILE;
      break;

    case NewsFeedsType.PRODUCT_ANALYSIS:
      iconName = MdsIcon.ANALYSIS;
      break;

    case NewsFeedsType.REPORT_NEWS:
      iconName = MdsIcon.REPORTING;
      break;

    case NewsFeedsType.IMPORT_COMPONENT:
    case NewsFeedsType.SHARING_NEWS:
      iconName = MdsIcon.PRODUCT_INFORMATION;
      break;
    default:
      break;
  }
  return iconName;
};

export const getNewsFeedActionName = (feedType: NewsFeedsType) => {
  let actionName = '';
  switch (feedType) {
    case NewsFeedsType.TEAM_MEMBER_NEWS:
      actionName = 'Go to profile';
      break;

    case NewsFeedsType.PRODUCT_ANALYSIS:
      actionName = 'Open analysis';
      break;

    case NewsFeedsType.REPORT_NEWS:
      actionName = 'See report';
      break;

    case NewsFeedsType.IMPORT_COMPONENT:
    case NewsFeedsType.SHARING_NEWS:
      actionName = 'View product';
      break;
    default:
      break;
  }
  return actionName;
};
